import React, { useState, useEffect } from "react";
import { Form, Button, Table, Modal, Card, Row, Col } from "@themesberg/react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import axiosInstance from "../../../api/api";
import CardLayout from "../Layout/CardLayout";

const MercadoConsumida = (ciemId) => {
    const [formData, setFormData] = useState({
        continente: "",
        moneda: "",
        tasaCambio: "",
        ciemId: ciemId.ciemId,
        detailContributionDTOList: [],
        totalMercadoNacionalConsumidas: 0,
        totalMercadoInternacionalConsumidas: 0,
        descripcionMercadoConsumidas: ""
    });

    const [tableHeaders, setTableHeaders] = useState([]);
    const [infoModal, setInfoModal] = useState({ show: false, content: '' });

    useEffect(() => { // Reemplaza con la URL de tu API de títulos

        //titulos y campos consumida Objetivo
        axiosInstance.get('/detailoption/option/value/mercadoConsumidaTable').then((response) => {
            setTableHeaders(response.data.data);
            console.log("tabla contribution" + tableHeaders)
        }).catch((e) => {
            alert("Error consultando la tabla " + e)
        });

        if (ciemId.ciemId) {
            axiosInstance.get('/contribution/' + ciemId.ciemId).then((response) => {
                if (response) {
                    setFormData(response.data.data);
                }
                console.log("informacion guardada" + formData)
            }).catch((e) => {
                alert("Error consultando la tabla " + e)
            });
        }

    }, []);


    const handleDetailChange = (index, field, value) => {
        console.log("cuando edita")
        console.log(field)
        console.log(value)
        const newDetails = [...formData.detailContributionDTOList];
        newDetails[index][field.value] = value;
        setFormData({ ...formData, detailContributionDTOList: newDetails });
        console.log("formulario final")
        console.log(formData)
        axiosInstance.post('/contribution/calculate', formData).then((response) => {
            //setTableHeaders(response.data.data);
            console.log("respuesta c")
            setFormData(response.data.data)
        }).catch((e) => {
            alert("Error de calculo " + e)
        });

    };

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log(formData);
        axiosInstance.post('/contribution/', formData).then((response) => {
            //setTableHeaders(response.data.data);
            console.log("respuesta guardado")
            setFormData(response.data.data)
        }).catch((e) => {
            alert("Error guardando la informacion " + e)
        });;
    };

    const contributionForm = <Form onSubmit={handleSubmit}>
        <Row>
            <Col md={6}>
                <Form.Group controlId="continente">
                    <Form.Label>Continente</Form.Label>
                    <Form.Control
                        type="text"
                        name="continente"
                        value={formData.continente}
                        readOnly={true}
                    />
                </Form.Group>
            </Col>

            <Col md={6}>
                <Form.Group controlId="moneda">
                    <Form.Label>Moneda</Form.Label>
                    <Form.Control
                        type="text"
                        name="moneda"
                        value={formData.moneda}
                        readOnly={true}
                    />
                </Form.Group>
            </Col>
        </Row>

        <Row>
            <Col md={6}>
                <Form.Group controlId="tasaCambio">
                    <Form.Label>Tasa de Cambio</Form.Label>
                    <Form.Control
                        type="text"
                        name="tasaCambio"
                        value={formData.tasaCambio}
                        readOnly={true}
                    />
                </Form.Group>
            </Col>
        </Row>
        <p></p>
        <h3>Valor mensual de la participación en el mercado objetivo</h3>
        <div style={{ overflowX: "auto" }}>
            <Table striped bordered hover>
                <thead>
                    <tr>
                        {tableHeaders.map((titulo) => (
                            <th key={titulo.id}>
                                <span className="d-flex align-items-center gap-1">
                                    {titulo.description}
                                    {titulo.tooltip && (
                                        <Button
                                            variant="link"
                                            size="sm"
                                            className="p-0 text-info"
                                            onClick={() => setInfoModal({ show: true, content: titulo.tooltip })}
                                            title="Ver información"
                                        >
                                            <FontAwesomeIcon icon={faInfoCircle} />
                                        </Button>
                                    )}
                                </span>
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {formData.detailContributionDTOList.map((detail, index) => (
                        <tr key={index}>
                            {tableHeaders.map((header, idx) => (
                                <td key={idx}>
                                    <Form.Control
                                        type="text"
                                        value={detail[header.value] || ""}
                                        onChange={(e) => handleDetailChange(index, header, e.target.value)}
                                        readOnly={!header.editable}
                                    />
                                </td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </Table>
        </div>

        <p></p>
        <h3>Totales</h3>
        <Table striped bordered>
            <tbody>
                <tr>
                    <td>Valor total del mercado Objetivo en moneda nacional</td>
                    <td>{formData.totalMercadoNacionalConsumidas}</td>
                </tr>
                <tr>
                    <td>Valor total del mercado Objetivo en dólares de USA</td>
                    <td>{formData.totalMercadoInternacionalConsumidas}</td>
                </tr>
            </tbody>
        </Table>
        <div>
            <p></p>
            <p>¿El valor del mercado objetivo indica que quienes actualmente compran el producto o su sustituto próximo son suficientes para generar riqueza con este modelo de negocio si se toma un porcentaje de ellos compitiendo dinámicamente? </p>
            <Form.Group className="mb-3">
                <Form.Control
                    as="textarea"
                    rows={5} // Aumentar las filas para que sea más grande
                    value={formData.descripcionMercadoConsumidas}
                    name="descripcionMercadoConsumidas"
                    onChange={handleChange}
                    maxLength={1000}
                    style={{ width: '100%' }} // Ocupar el 100% del ancho
                />
            </Form.Group>
        </div>

        <Button variant="primary" type="submit">
            Guardar
        </Button>

        {/* Modal de información */}
        <Modal show={infoModal.show} onHide={() => setInfoModal({ show: false, content: '' })}>
            <Modal.Header closeButton>
                <Modal.Title>Información</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div dangerouslySetInnerHTML={{ __html: infoModal.content }} />
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={() => setInfoModal({ show: false, content: '' })}>
                    Cerrar
                </Button>
            </Modal.Footer>
        </Modal>
    </Form>
        ;

    return (
        <div className="container-fluid">
            <CardLayout value={"consumidaMercadoTitulo"} tablaComponent={contributionForm} />
        </div>
    );
};

export default MercadoConsumida;
